module.exports = __webpack_public_path__ + "static/media/article.04b90bc0.svg";